import styles from "./SellerCard.module.scss";
import { formatMoney, formatPercent } from "../../utils/formatters";

interface Props {
  title: string;
  money: number;
  earnings: number;
  isPercentage?: boolean;
  goodIfPositive?: boolean;
  moneyDecimals?: number;
}

export function SellerCard({
  title,
  money,
  earnings,
  isPercentage = false,
  goodIfPositive = true,
  moneyDecimals,
}: Props) {
  const mainValueFormatted = isPercentage
    ? formatPercent(money)
    : formatMoney(money, { decimals: moneyDecimals });

  const earningsFormatted = isPercentage
    ? formatPercent(earnings, true)
    : formatMoney(earnings, { showSign: true, decimals: moneyDecimals });

  const isGood = goodIfPositive ? earnings >= 0 : earnings <= 0;

  return (
    <div className={styles.SellerCard}>
      <div className={styles.SellerCardTop}>
        <div className={styles.title}>{title}</div>
        <div className={styles.mainValue}>
          <span className={styles.valueNumber}>{mainValueFormatted.main}</span>
          <span className={styles.valueSuffix}>
            {mainValueFormatted.suffix}
          </span>
        </div>
      </div>
      <div
        className={`${styles.earnings} ${isGood ? styles.positive : styles.negative}`}
      >
        <div>
          <span className={styles.earningsNumber}>
            {earningsFormatted.main}
          </span>
          <span className={styles.earningsSuffix}>
            {earningsFormatted.suffix}
          </span>
        </div>
      </div>
    </div>
  );
}
